<template>
  <div>
    <div class="p-4 text-base text-left leading-snug max-h-96 overflow-auto bg-charcoal-100 dark:bg-dark-950">      
      <div class="bg-white dark:bg-dark-800 dark:text-dark-50 px-3 pt-3 pb-2 rounded-xl text-light-950 shadow overflow-hidden">
        <CarouselSwipe width="full" pagination="dots" effect="opacity" :spacing="20" v-model="position" class="relative z-10 pb-3">
          <template v-for="(step, i) in tutorial" #[step.id]>
            <div class="text-center">
              <div class="max-w-xs mx-auto">
                <ImageEmoji :name="step.emoji" class="size-12 mt-2 mx-auto" v-if="step.emoji" />

                <p class="font-bold text-2xl mt-2 mb-2" v-if="step.title">{{ step.title }}</p>

                <div>
                  <slot :name="step.id" />
                  {{ step.description }}
                </div>
              </div>
            </div>
          </template>
        </CarouselSwipe>
      </div>
    </div>

    <div class="bg-white border-t border-charcoal-200 dark:bg-dark-800 dark:dark:border-dark-600 flex items-center space-x-2 p-2.5">
      <ButtonBase style-type="round" class="shrink-0" color="white" @click="onPrevious">
        <IconBase name="cute/angle-right" class="rotate-180" :width="20" />
      </ButtonBase>

      <ButtonBase color="base" is-full @click="onNext">
        {{ $t('actions.next') }}
      </ButtonBase>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Event } from '@/classes'
import UserStore from '@/store/user'

const props = withDefaults(defineProps<{
  event: Event
}>(), {

})

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'previous'): void
  (e: 'reset'): void
}>()

const position = ref(0)

const tutorial = [
  {
    id: 'step1',
    title: useNuxtApp().$i18n.t('components.Event.tutorial.step1.title'),
    emoji: 'Grinning+Face',
    description: useNuxtApp().$i18n.t('components.Event.tutorial.step1.content')
  },
  {
    id: 'step2',
    title: useNuxtApp().$i18n.t('components.Event.tutorial.step2.title'),
    emoji: 'Heart+Hands',
    description: useNuxtApp().$i18n.t('components.Event.tutorial.step2.content')
  },
  {
    id: 'step3',
    title: useNuxtApp().$i18n.t('components.Event.tutorial.step3.title'),
    emoji: 'Handshake',
    description: useNuxtApp().$i18n.t('components.Event.tutorial.step3.content')
  },
  {
    id: 'step4',
    title: useNuxtApp().$i18n.t('components.Event.tutorial.step4.title'),
    emoji: 'Smiling+Face+with+Halo',
    description:  useNuxtApp().$i18n.t('components.Event.tutorial.step4.content')
  },
]

const onPrevious = () => {
  if (position.value === 0) {
    emit('previous')
  } else {
    position.value--
  }
}

const onNext = () => {
  if (position.value === tutorial.length - 1) {
    userStore.updateJourney('info-attend')
    
    emit('next')
  } else {
    position.value++
  }
}

</script>